import rightImg from "images/rightimg.png";
import SectionGridFeaturePlaces from "./SectionGridFeaturePlaces";
import SectionHero from "containers/PageAbout/SectionHero";
import SectionClientSay from "components/SectionClientSay/SectionClientSay";
import { globalJson } from "global/global_json";
import { ChangeEvent, useEffect, useState } from "react";

import SiteHeader from "containers/SiteHeader";
import MobileSearch from "components/MobileSearchForm/MobileSearch";
import BrowseByBrands from "components/BrowseBrand/BrowseBrand";
import BrowseLocation from "components/BrowseLocation/BrowseLocation";
import CarRentalSteps from "components/Steps/Steps";
import FAQ from "components/FAQ/FAQ";
import SectionHero4 from "components/SectionHero/SectionHero";
import DreamCarSection from "components/DreamCar/DreamCar";
import ModalPic from "images/modal.jpg";
import PhoneInput from "react-phone-input-2";
import { useData } from "data/data-provider";
import { AddCustomer } from "api/customer/customer";
import toast from "react-hot-toast";

function PageHome3() {
  const [showModal, setShowModal] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  useEffect(() => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user");

    const timer = setTimeout(() => {
      setShowModal(true);
    }, 7000);
    return () => clearTimeout(timer);
  }, []);

  const validateForm = () => {
    const newErrors: { [key: string]: string } = {};
    if (!firstName) newErrors.firstName = "First Name is required";
    if (!lastName) newErrors.lastName = "Last Name is required";
    if (!email || !/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(email)) {
      newErrors.email = "Please enter a valid email address";
    }
    if (!phone || phone.length < 10) {
      newErrors.phone = "Please enter a valid phone number";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const clearError = (field: string) => {
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[field];
      return updatedErrors;
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        const payload = {
          first_name: firstName,
          last_name: lastName,
          email: email,
          phone: phone,
          company:
            process.env.REACT_APP_ENV !== "prod"
              ? globalJson.dev_company_id
              : globalJson.prod_company_id,
        };

        const response = await AddCustomer(payload);

        if (response && response.data) {
          // Handle successful submission
          toast.success("Signed Up Successfully");
          setShowModal(false);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        setShowModal(false);
      }
    }
  };

  return (
    <>
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/50">
          <div className="relative w-full max-w-xl overflow-hidden rounded-lg">
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-3 right-3 bg-black/20 rounded-full hover:bg-black/30 z-10"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>

            {/* Background image container */}
            <div
              className="bg-cover bg-center w-full h-[600px]"
              style={{ backgroundImage: `url(${ModalPic})` }}
            >
              <div className="absolute inset-0 bg-gradient-to-b from-black/30 to-black/60"></div>

              {/* Content overlay */}
              <div className="relative z-1 h-full flex flex-col items-center justify-center py-36">
                {/* Logo */}
                <div className="text-white text-center mb-2">
                  <h2 className="text-2xl md:text-3xl font-bold">
                    Join Supre Auto Group
                  </h2>
                  <p className="text-2xl md:text-4xl font-bold mt-2">
                    Receive 5% OFF
                    <br />
                    your first rental
                  </p>
                </div>

                {/* Form fields */}
                <div className="w-full max-w-md mt-8">
                  <form onSubmit={handleSubmit}>
                    <div className="space-y-4">
                      <div>
                        <input
                          type="text"
                          placeholder="First Name"
                          value={firstName}
                          onChange={(e: ChangeEvent<HTMLInputElement>) => {
                            setFirstName(e.target.value);
                            if (e.target.value) clearError("firstName");
                          }}
                          className="w-full px-4 py-3.5 rounded bg-transparent text-white placeholder-white focus:outline-none"
                        />
                        {errors.firstName && (
                          <span className="text-red-400 text-xs font-semibold">
                            {errors.firstName}
                          </span>
                        )}
                      </div>

                      <div>
                        <input
                          type="text"
                          placeholder="Last Name"
                          value={lastName}
                          onChange={(e: ChangeEvent<HTMLInputElement>) => {
                            setLastName(e.target.value);
                            if (e.target.value) clearError("lastName");
                          }}
                          className="w-full px-4 py-3.5 rounded bg-transparent text-white placeholder-white focus:outline-none"
                        />
                        {errors.lastName && (
                          <span className="text-red-400 text-xs font-semibold">
                            {errors.lastName}
                          </span>
                        )}
                      </div>

                      <div>
                        <input
                          type="email"
                          placeholder="Email"
                          value={email}
                          onChange={(e: ChangeEvent<HTMLInputElement>) => {
                            setEmail(e.target.value);
                            if (
                              /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(
                                e.target.value
                              )
                            ) {
                              clearError("email");
                            }
                          }}
                          className="w-full px-4 py-3.5 rounded bg-transparent text-white placeholder-white focus:outline-none"
                        />
                        {errors.email && (
                          <span className="text-red-400 text-xs font-semibold">
                            {errors.email}
                          </span>
                        )}
                      </div>

                      <div className="relative">
                        <PhoneInput
                          country={"us"}
                          value={phone}
                          onChange={(phone) => {
                            setPhone(phone);
                            if (phone.length >= 10) clearError("phone");
                          }}
                          containerClass="w-full"
                          inputClass="w-full px-4 py-3.5 rounded bg-transparent text-white placeholder-white focus:outline-none"
                          buttonClass="absolute top-0 left-0 h-full"
                          inputProps={{
                            name: "phone",
                            required: true,
                            placeholder: "Phone",
                            color: "white",
                          }}
                          inputStyle={{
                            width: "100%",
                            background: "none",
                            height: "52px", // Match the height of other inputs
                            border: "1px solid #ccc",
                            paddingLeft: "48px", // Leave space for country flag
                          }}
                          buttonStyle={{
                            background: "transparent",
                            border: "none",
                            padding: "0 12px",
                          }}
                        />
                        {errors.phone && (
                          <span className="text-red-400 text-xs font-semibold">
                            {errors.phone}
                          </span>
                        )}
                      </div>

                      <div className="pt-4">
                        <button
                          type="submit"
                          className="w-full p-4 bg-green-500 text-white font-bold rounded uppercase tracking-wide hover:bg-green-600 transition-colors"
                        >
                          Sign up for Newsletter
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="nc-PageHome3 relative overflow-hidden">
        <div
          className={
            "lg:bg-[url('images/travelhero2.png')] bg-[url('images/travelheromobile.png')] justify-between flex flex-col bg-cover md:bg-center w-full h-screen"
          }
        >
          <div className="container relative px-0 z-40">
            <div className="md:pt-4">
              <div className="rounded-3xl overflow-clip">
                <SiteHeader />
              </div>
            </div>
            <div className="lg:hidden mt-36 px-4 md:px-0 mb-16 md:mb-0">
              <MobileSearch />
            </div>
            <div className="container relative lg:pb-16 lg:pt-8 md:pt-0 sm:pt-0 px-0 md:pb-0 sm:pb-0 mt-0">
              <SectionHero4 />
            </div>
          </div>
        </div>
        {/* <div className="container py-16  space-y-16 lg:space-y-28">
          <BrowseByBrands />
        </div> */}
        {/* </div> */}
        <div className="container  relative py-16 ">
          <div className="bg-[#F5F5F7] rounded-2xl p-4 md:p-12">
            <SectionGridFeaturePlaces />
          </div>
        </div>
        {/* <div className="container relative" style={{ padding: "0px" }}>
          <div className="container py-16  space-y-16 lg:space-y-28">
            <SectionHero
              rightImg={rightImg}
              heading="Welcome to Kings Car Rentals"
              btnText=""
              subHeading={globalJson?.about_us_para}
            />
          </div>
        </div> */}
        <div className="container py-16">
          <DreamCarSection />
        </div>

        <div className="container py-16  space-y-16 lg:space-y-28">
          {" "}
          <BrowseLocation />
        </div>

        <div className="container relative py-16">
          <div className="bg-[#EFFEF2] py-6 rounded-xl">
            {/* <BackgroundSection /> */}
            <SectionClientSay uniqueClassName="PageAbout_" />
          </div>
        </div>
      </div>
      <div className="container py-16   space-y-16 lg:space-y-28">
        {" "}
        <FAQ />
      </div>
    </>
  );
}

export default PageHome3;
